import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

import routes from '../../../../routes/routes.json';
import styles from '../../../../styles/mlp-landing.module.css';

interface Props {
  otp: string[];
  setOtp: React.Dispatch<React.SetStateAction<string[]>>;
}

export const OtpInput = ({ otp, setOtp }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [activeOTPIndex, setActiveOTPIndex] = useState<number>(0);
  const [currentOtpIndex, setCurrentOtpIndex] = useState<number>(0);
  const route = useRouter();

  const su = route.pathname === routes.goldLoansApply;

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOTPIndex]);

  const handleChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = target;
    const newOtp: string[] = [...otp];
    newOtp[currentOtpIndex] = value.substring(value.length - 1);
    if (!value) {
      setActiveOTPIndex(currentOtpIndex - 1);
    } else {
      setActiveOTPIndex(Math.min(currentOtpIndex + 1, otp.length - 1));
    }
    setOtp(newOtp);
  };

  const handleOnKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    setCurrentOtpIndex(index);
    if (e.key === 'Backspace') {
      setActiveOTPIndex(Math.max(currentOtpIndex - 1, 0));
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    } else if (e.key !== 'Enter' && !/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="input-container">
      <div className="otp-wrapper justify-content-center mt-0">
        {otp.map((_, index) => {
          return (
            <input
              data-hj-allow
              type="number"
              className={su ? `${styles.custoptbtn}` : 'otp-input'}
              ref={index === activeOTPIndex ? inputRef : null}
              onChange={handleChange}
              onKeyDown={(e) => handleOnKeyDown(e, index)}
              onWheel={(e) => e.currentTarget.blur()}
              value={otp[index]}
              pattern="[0-9]*"
              autoFocus={index === 1}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};
